import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LockedFeatureBanner = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 to-accent/10 border border-primary/30 rounded-lg p-6 mb-8">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center shrink-0">
            <Icon name="Lock" size={24} color="var(--color-primary)" strokeWidth={2} />
          </div>
          <div>
            <h3 className="text-lg font-bold text-foreground mb-1">
              Full Tool Integration Coming Soon
            </h3>
            <p className="text-muted-foreground text-sm mb-2">
              This comprehensive tool management system will be available in the full release
            </p>
            <div className="flex flex-wrap gap-2">
              <div className="flex items-center gap-1 text-xs text-primary">
                <Icon name="CheckCircle2" size={14} color="var(--color-primary)" />
                <span>Automated provisioning</span>
              </div>
              <div className="flex items-center gap-1 text-xs text-primary">
                <Icon name="CheckCircle2" size={14} color="var(--color-primary)" />
                <span>Single sign-on</span>
              </div>
              <div className="flex items-center gap-1 text-xs text-primary">
                <Icon name="CheckCircle2" size={14} color="var(--color-primary)" />
                <span>Real-time sync</span>
              </div>
            </div>
          </div>
        </div>
        <Button variant="default" iconName="Sparkles" iconPosition="left" className="shrink-0">
          Learn More
        </Button>
      </div>
    </div>
  );
};

export default LockedFeatureBanner;